module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel",
    attrs: {
      "id": "page__users"
    }
  }, [_c('md-content', {
    attrs: {
      "md-theme": "white",
      "loading": _vm.progress
    }
  }, [_c('user-menu'), _vm._v(" "), _c('sort-table', {
    attrs: {
      "columns": _vm.tableColumns,
      "per-page": _vm.perPage,
      "total": _vm.usersAmount,
      "table-id": "users",
      "tableHeight": "calc(100% - 48px)",
      "link": ""
    },
    on: {
      "refresh": _vm.getUsers,
      "create": _vm.addUser
    },
    scopedSlots: _vm._u([{
      key: "last_login",
      fn: function(scope) {
        return [(scope.item.last_login) ? _c('span', [_vm._v(" " + _vm._s(_vm.moment(scope.item.last_login).format('DD.MM.YYYY HH:mm')))]) : _vm._e()]
      }
    }, {
      key: "is_blocked",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(parseInt(scope.item.is_blocked) === 1 ? 'Заблокирован' : 'Не заблокирован'))])]
      }
    }, {
      key: "actions",
      fn: function(scope) {
        return [_c('z-icon-button', {
          attrs: {
            "icon": ['fa', 'trash'],
            "danger-light": "",
            "rounded": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              _vm.onRemove(scope.item.id)
            }
          }
        })]
      }
    }, {
      key: "groups",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "chips"
        }, _vm._l((scope.item.groups), function(item) {
          return _c('div', {
            staticClass: "chip"
          }, [_vm._v(_vm._s(item.name))])
        }))]
      }
    }]),
    model: {
      value: (_vm.users),
      callback: function($$v) {
        _vm.users = $$v
      },
      expression: "users"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9b03bfe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/users/views/Users.vue
// module id = 1255
// module chunks = 0